import TimePicker from '../date-picker/picker/time-picker';
export default TimePicker;


// WEBPACK FOOTER //
// ./src/components/time-picker/index.js